export const AREA_PAGE_UUID = '44f9fd30-d127-40c9-85b4-4ff11e1a8fa0'

// 管理地址
export const AREA_ACTION_UUID = '1c3f86a0-673c-4f28-b0af-59b3b51fa59d'
